import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../../auth/auth.service';
import { GeneralRoutePaths } from '../enums/route-types.enum';
import { UserRole } from '../enums/user-role.enum';
import { UserInterface } from '../models/user.model';
import { RegularUserGuardService } from '../services/regular-user-guard/regular-user-guard.service';
import { SonataSessionService } from '../services/sonata-session/sonata-session.service';

@Injectable({
  providedIn: 'root',
})
export class NotAdminGuard {
  private authService = inject(AuthService);
  private regularUserGuardService = inject(RegularUserGuardService);
  private router = inject(Router);
  private sonataSessionService = inject(SonataSessionService);

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    const allowAdmin = this.regularUserGuardService.shouldAllowAdmin(next);
    const user: UserInterface = this.authService.getUser();

    if (user && user.role && user.role.name === UserRole.ROLE_ADMIN && user.redirect && !allowAdmin) {
      if (user.redirect === state.url) {
        this.router.navigate(['/', GeneralRoutePaths.FORBIDDEN]);

        return false;
      }

      this.sonataSessionService.openRedirect(user.redirect);

      return false;
    }

    return true;
  }
}
